export default __webpack_public_path__ + "static/media/github.237e2214.png";